import { makeDataSample } from "./index.preview";
import { debuglog } from "../utility/debuglog";

let highTrafficSimulationInterval = null;

export default [
  {
    name: 'add',
    class: 'btn-add-item',
    label: 'Add Event Item',
    exec: async (manager) => {
      
      let data = makeDataSample()
      debuglog(`New tip from ${data.supporter_name} 💰 ${(manager.widget.setting['ef_quantity_type'] === 'unit') ? data.quantity + ' ' + data.unit : 'Rp ' + data.price}`);
      await manager.addEventFeed(data);
    }
  },
  {
    name: 'toggleHide',
    class: 'btn-toggle-hide-list',
    label: 'Toggle Hide',
    exec: (manager) => {
      debuglog(`Toggle hide`);
      manager.widget.toggleVisibility(!manager.widget.isShowList);
    }
  },
  {
    name: 'simulateHighTraffic',
    class: 'btn-simulate-high-traffic',
    label: 'Simulate High Traffic',
    exec: (manager) => {
      
      // Clear interval if already running
      if (highTrafficSimulationInterval) {
        clearInterval(highTrafficSimulationInterval);
        highTrafficSimulationInterval = null;
        // alert('Stop simulation');
        debuglog(`Stop simulation`);
        return;
      }

      // Counter to keep track of executions
      let executionCount = 0;

      // Set an interval to execute the function every second (1000 ms)
      highTrafficSimulationInterval = setInterval(() => {
        let data = makeDataSample()
        debuglog(`New tip from ${data.supporter_name} 💰 ${(manager.widget.setting['ef_quantity_type'] === 'unit') ? data.quantity + ' ' + data.unit : 'Rp ' + data.price}`);
        manager.addEventFeed(data)
        executionCount++;

        // Stop the execution after 1000 times
        if (executionCount >= 1000) {
          clearInterval(highTrafficSimulationInterval);
        }
      }, 500);
    }
  },
  {
    name: 'LongText',
    class: 'btn-debug-longtext',
    label: 'Long Text',
    exec: (manager) => {
      let text = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
      let temp = h.cloneProp(manager.widget.data);
      temp.supporter_message = text;
      temp.supporter_name = "Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis Egis"
      temp.quantity = 9999
      manager.addEventFeed(temp);
      
      debuglog(`Check long text input`);
    }
  },
  {
    name: 'emptyState',
    class: 'btn-debug-emptystate',
    label: 'Empty State',
    exec: async (manager) => {
      manager.addEventFeedEmpty("trakteer.id/username/gift")
      debuglog("Reset to empty state")
    }
  },
]